import React, { useState, useRef, useEffect } from 'react';
import YarnBallIcon from '../components/YarnBallIcon';

const API_URL = '';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#FDF8F5',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '20px 32px',
    background: '#FFFFFF',
    borderBottom: '1px solid #EDE8E3',
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  },
  backBtn: {
    background: '#F5F0EB',
    border: 'none',
    borderRadius: '999px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#6B6B6B',
    cursor: 'pointer',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#2D2D2D',
  },
  headerSub: {
    fontSize: '13px',
    color: '#A0A0A0',
    marginTop: '2px',
  },
  avatar: {
    width: '44px',
    height: '44px',
    borderRadius: '999px',
    background: 'linear-gradient(135deg, #F7C948, #F4A261, #F08080)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    marginLeft: 'auto',
  },
  modeToggle: {
    display: 'flex',
    gap: '8px',
    padding: '4px',
    background: '#F5F0EB',
    borderRadius: '999px',
    marginLeft: '16px',
  },
  modeBtn: (active, color) => ({
    padding: '8px 16px',
    borderRadius: '999px',
    fontSize: '13px',
    fontWeight: 500,
    border: 'none',
    background: active ? color : 'transparent',
    color: active ? '#2D2D2D' : '#6B6B6B',
    cursor: 'pointer',
    transition: 'all 0.2s',
  }),
  messages: {
    flex: 1,
    overflowY: 'auto',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '760px',
    width: '100%',
    margin: '0 auto',
  },
  welcomeCard: {
    background: 'linear-gradient(135deg, #FDF3E7, #F9E8F0)',
    borderRadius: '24px',
    padding: '32px',
    textAlign: 'center',
    border: '1px solid rgba(247,201,72,0.2)',
  },
  welcomeEmoji: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  welcomeTitle: {
    fontSize: '22px',
    fontWeight: 600,
    fontFamily: "'Playfair Display', serif",
    color: '#2D2D2D',
    marginBottom: '12px',
  },
  welcomeText: {
    fontSize: '15px',
    color: '#6B6B6B',
    lineHeight: 1.7,
  },
  messageBubble: (isAI) => ({
    display: 'flex',
    justifyContent: isAI ? 'flex-start' : 'flex-end',
    alignItems: 'flex-end',
    gap: '12px',
  }),
  bubble: (isAI) => ({
    maxWidth: '70%',
    padding: '16px 20px',
    borderRadius: isAI ? '24px 24px 24px 6px' : '24px 24px 6px 24px',
    background: isAI ? '#FFFFFF' : 'linear-gradient(135deg, #F7C948, #F4A261)',
    color: isAI ? '#2D2D2D' : '#2D2D2D',
    fontSize: '15px',
    lineHeight: 1.7,
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    border: isAI ? '1px solid #EDE8E3' : 'none',
  }),
  aiAvatarSmall: {
    width: '32px',
    height: '32px',
    borderRadius: '999px',
    background: 'linear-gradient(135deg, #C3A8E1, #63C5DA)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    flexShrink: 0,
  },
  typingDots: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    padding: '16px 20px',
    background: '#FFFFFF',
    borderRadius: '24px 24px 24px 6px',
    border: '1px solid #EDE8E3',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  },
  dot: (delay) => ({
    width: '8px',
    height: '8px',
    borderRadius: '999px',
    background: '#C3A8E1',
    animation: 'bounce 1.4s infinite',
    animationDelay: delay,
  }),
  inputArea: {
    padding: '20px 32px',
    background: '#FFFFFF',
    borderTop: '1px solid #EDE8E3',
  },
  inputWrapper: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-end',
    maxWidth: '760px',
    margin: '0 auto',
    background: '#F5F0EB',
    borderRadius: '20px',
    padding: '12px 16px',
  },
  textarea: {
    flex: 1,
    border: 'none',
    background: 'transparent',
    fontSize: '15px',
    color: '#2D2D2D',
    resize: 'none',
    outline: 'none',
    lineHeight: 1.6,
    maxHeight: '120px',
    minHeight: '24px',
    fontFamily: 'Inter, sans-serif',
  },
  sendBtn: (hasText) => ({
    width: '40px',
    height: '40px',
    borderRadius: '999px',
    background: hasText ? 'linear-gradient(135deg, #F7C948, #F4A261)' : '#EDE8E3',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: hasText ? 'pointer' : 'default',
    transition: 'all 0.2s',
    flexShrink: 0,
    fontSize: '18px',
  }),
  micBtn: (recording) => ({
    width: '40px',
    height: '40px',
    borderRadius: '999px',
    background: recording ? 'linear-gradient(135deg, #F08080, #F4A261)' : '#EDE8E3',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s',
    flexShrink: 0,
    fontSize: '18px',
    boxShadow: recording ? '0 0 0 4px rgba(240,128,128,0.25)' : 'none',
    animation: recording ? 'pulse 1.5s infinite' : 'none',
  }),
};

const prompts = [
  "How are you feeling right now?",
  "What's been on your mind lately?",
  "Tell me about your day",
  "What are you grateful for today?",
];

export default function CompanionChat({ navigate, userId, conversationRef }) {
  const [messages, setMessages] = useState(conversationRef?.current || []);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('companion');
  const [recording, setRecording] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  const [ttsEnabled, setTtsEnabled] = useState(false);
  const [savedMessages, setSavedMessages] = useState(new Set());
  const [sessionSaved, setSessionSaved] = useState(false);
  const [saveNotice, setSaveNotice] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const messagesEndRef = useRef(null);

  // Sync messages to persistent ref so they survive navigation
  useEffect(() => {
    if (conversationRef) conversationRef.current = messages;
  }, [messages, conversationRef]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  const sendMessage = async (text) => {
    const msg = text || input.trim();
    if (!msg || loading) return;
    setInput('');

    const userMsg = { role: 'user', content: msg };
    setMessages(prev => [...prev, userMsg]);
    setLoading(true);

    try {
      const history = messages.map(m => ({ role: m.role, content: m.content }));
      const res = await fetch(`${API_URL}/api/companion/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, message: msg, conversationHistory: history, mode }),
      });
      const data = await res.json();
      if (data.response) {
        setMessages(prev => [...prev, { role: 'assistant', content: data.response }]);
        speak(data.response);
      }
    } catch (e) {
      setMessages(prev => [...prev, { role: 'assistant', content: "I'm having trouble connecting right now. Please try again." }]);
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };



  const startRecording = async () => {
    // Try browser speech recognition first (simpler, no transcription server needed)
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      try {
        const recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.interimResults = true;
        recognition.lang = 'en-US';

        let finalTranscript = '';
        setRecording(true);

        recognition.onresult = (e) => {
          let interim = '';
          for (let i = e.resultIndex; i < e.results.length; i++) {
            if (e.results[i].isFinal) {
              finalTranscript += e.results[i][0].transcript;
            } else {
              interim += e.results[i][0].transcript;
            }
          }
          // Show interim in input as feedback
          if (interim) setInput(interim);
        };

        recognition.onend = () => {
          setRecording(false);
          setInput('');
          if (finalTranscript.trim()) {
            // Auto-send immediately
            sendMessage(finalTranscript.trim());
          }
        };

        recognition.onerror = (e) => {
          console.error('Speech recognition error:', e.error);
          setRecording(false);
          // Fall back to MediaRecorder
          startMediaRecorder();
        };

        // Store so we can stop it
        mediaRecorderRef.current = recognition;
        recognition.start();
        return;
      } catch (e) {
        console.error('Browser STT failed, falling back:', e);
      }
    }
    // Fall back to MediaRecorder + Whisper
    startMediaRecorder();
  };

  const startMediaRecorder = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = async () => {
        stream.getTracks().forEach(t => t.stop());
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        setTranscribing(true);
        try {
          // Try backend Whisper first
          const formData = new FormData();
          formData.append('audio', audioBlob, 'voice.webm');
          formData.append('userId', userId);
          const res = await fetch(`${API_URL}/api/companion/transcribe`, {
            method: 'POST',
            body: formData,
          });
          const data = await res.json();
          if (data.text && data.text.trim()) {
            // Auto-send — no button needed
            sendMessage(data.text.trim());
          }
        } catch (e) {
          console.error('Transcription failed:', e);
        } finally {
          setTranscribing(false);
        }
      };

      mediaRecorder.start();
      setRecording(true);
    } catch (e) {
      alert('Microphone access needed for voice messages. Please allow microphone in your browser settings.');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && recording) {
      // Works for both SpeechRecognition and MediaRecorder
      if (typeof mediaRecorderRef.current.stop === 'function') {
        mediaRecorderRef.current.stop();
      }
      setRecording(false);
      setInput('');
    }
  };

  const speak = (text) => {
    if (!ttsEnabled || !('speechSynthesis' in window)) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.9;
    utterance.pitch = 1.05;
    const voices = window.speechSynthesis.getVoices();
    const preferred = voices.find(v => v.name.includes('Samantha') || v.name.includes('Karen') || v.name.includes('Moira'));
    if (preferred) utterance.voice = preferred;
    window.speechSynthesis.speak(utterance);
  };

  const saveMessage = async (msg, idx) => {
    try {
      await fetch(`${API_URL}/api/diary/save-message`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, message: msg.content, role: msg.role }),
      });
      setSavedMessages(prev => new Set([...prev, idx]));
      setSaveNotice('Saved to your diary ✅');
      setTimeout(() => setSaveNotice(null), 2500);
    } catch (e) { console.error(e); }
  };

  const saveSession = async () => {
    if (messages.length === 0) return;
    try {
      await fetch(`${API_URL}/api/diary/save-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, messages }),
      });
      setSessionSaved(true);
      setTimeout(() => { setSessionSaved(false); navigate('history'); }, 1200);
    } catch (e) { console.error(e); }
  };

  const endSession = () => {
    setMessages([]);
    if (conversationRef) conversationRef.current = [];
    setSavedMessages(new Set());
    setSaveNotice('Session ended 👋');
    setTimeout(() => setSaveNotice(null), 2000);
  };

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes bounce {
          0%, 60%, 100% { transform: translateY(0); }
          30% { transform: translateY(-8px); }
        }
      `}</style>

      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate('dashboard')}>← Back</button>
        <div>
          <div style={styles.headerTitle}>AI Companion</div>
          <div style={styles.headerSub}>{mode === 'companion' ? '🌸 Companion mode — here for you' : '🔍 Diary mode — analyzing your journey'}</div>
        </div>
        <div style={styles.modeToggle}>
          <button style={styles.modeBtn(mode === 'companion', '#F7C948')} onClick={() => setMode('companion')}>💬 Companion</button>
          <button style={styles.modeBtn(false, '#C3A8E1')} onClick={() => navigate('history')}>📅 My Diary</button>
        </div>
        <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto', alignItems: 'center' }}>
          <button
            onClick={() => setTtsEnabled(!ttsEnabled)}
            style={{ background: ttsEnabled ? '#E8F7ED' : '#F5F0EB', border: `1px solid ${ttsEnabled ? '#7BC67E' : '#EDE8E3'}`, borderRadius: '999px', padding: '8px 16px', fontSize: '13px', fontWeight: 500, color: ttsEnabled ? '#4A9B5C' : '#6B6B6B', cursor: 'pointer' }}
          >
            {ttsEnabled ? '🔊 Voice ON' : '🔇 Voice OFF'}
          </button>
          {messages.length > 0 && (
            <button
              onClick={saveSession}
              disabled={sessionSaved}
              style={{ background: sessionSaved ? '#E8F7ED' : 'linear-gradient(135deg, #C3A8E1, #63C5DA)', border: 'none', borderRadius: '999px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, color: sessionSaved ? '#4A9B5C' : '#FFFFFF', cursor: sessionSaved ? 'default' : 'pointer', pointerEvents: sessionSaved ? 'none' : 'auto' }}
            >
              {sessionSaved ? '✅ Saved!' : '💾 Save session'}
            </button>
          )}

        </div>
        <div style={{ ...styles.avatar, background: 'transparent' }}>
          <YarnBallIcon size={36} />
        </div>
      </div>

      <div style={styles.messages}>
        {messages.length === 0 && (
          <div style={styles.welcomeCard}>
            <div style={styles.welcomeEmoji}><YarnBallIcon size={56} /></div>
            <div style={styles.welcomeTitle}>Hey, I'm your Life Map companion</div>
            <div style={styles.welcomeText}>
              I know your story. I've read your journal, I remember your moods, and I'm here — fully present. What's on your mind?
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '24px' }}>
              {prompts.map((p, i) => (
                <button key={i} onClick={() => sendMessage(p)} style={{
                  background: '#FFFFFF',
                  border: '1px solid #EDE8E3',
                  borderRadius: '999px',
                  padding: '10px 18px',
                  fontSize: '13px',
                  color: '#6B6B6B',
                  cursor: 'pointer',
                  transition: 'border-color 0.2s',
                }}>
                  {p}
                </button>
              ))}
            </div>
          </div>
        )}

        {messages.map((msg, i) => (
          <div key={i} style={{ ...styles.messageBubble(msg.role === 'assistant'), flexDirection: 'column', alignItems: msg.role === 'assistant' ? 'flex-start' : 'flex-end' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '12px', width: '100%', justifyContent: msg.role === 'assistant' ? 'flex-start' : 'flex-end' }}>
              {msg.role === 'assistant' && <div style={{ ...styles.aiAvatarSmall, background: 'transparent' }}><YarnBallIcon size={32} /></div>}
              <div style={styles.bubble(msg.role === 'assistant')}>
                {msg.content}
              </div>
            </div>
            <div style={{ marginTop: '6px', marginLeft: msg.role === 'assistant' ? '44px' : '0', display: 'flex', gap: '8px' }}>
              <button
                onClick={() => saveMessage(msg, i)}
                disabled={savedMessages.has(i)}
                style={{ background: savedMessages.has(i) ? '#E8F7ED' : 'transparent', border: `1px solid ${savedMessages.has(i) ? '#7BC67E' : '#EDE8E3'}`, borderRadius: '999px', padding: '4px 12px', fontSize: '11px', color: savedMessages.has(i) ? '#4A9B5C' : '#A0A0A0', cursor: savedMessages.has(i) ? 'default' : 'pointer', pointerEvents: savedMessages.has(i) ? 'none' : 'auto' }}
              >
                {savedMessages.has(i) ? '✅ Saved' : (msg.role === 'user' ? '💾 Save entry' : '💾 Save insight')}
              </button>
              {msg.role === 'assistant' && ttsEnabled && (
                <button
                  onClick={() => speak(msg.content)}
                  style={{ background: 'transparent', border: '1px solid #EDE8E3', borderRadius: '999px', padding: '4px 12px', fontSize: '11px', color: '#A0A0A0', cursor: 'pointer' }}
                >
                  🔊 Play
                </button>
              )}
            </div>
          </div>
        ))}

        {loading && (
          <div style={styles.messageBubble(true)}>
            <div style={styles.aiAvatarSmall}>🧶</div>
            <div style={styles.typingDots}>
              <div style={styles.dot('0s')} />
              <div style={styles.dot('0.2s')} />
              <div style={styles.dot('0.4s')} />
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {saveNotice && (
        <div style={{ position: 'fixed', bottom: '100px', left: '50%', transform: 'translateX(-50%)', background: '#2D2D2D', color: '#FFFFFF', padding: '12px 24px', borderRadius: '999px', fontSize: '14px', fontWeight: 500, boxShadow: '0 4px 16px rgba(0,0,0,0.2)', zIndex: 1000 }}>
          {saveNotice}
        </div>
      )}
      <div style={styles.inputArea}>
        <div style={styles.inputWrapper}>
          <button
            style={{
              ...styles.micBtn(recording),
              background: recording ? 'rgba(240,128,128,0.1)' : 'transparent',
              border: recording ? '2px solid rgba(240,128,128,0.4)' : '2px solid transparent',
            }}
            onClick={recording ? stopRecording : startRecording}
            title={recording ? 'Tap to stop & send' : 'Tap to speak'}
          >
            {transcribing
              ? <span style={{ fontSize: '16px' }}>⏳</span>
              : <YarnBallIcon size={36} recording={recording} asMic={true} />
            }
          </button>
          <textarea
            style={styles.textarea}
            placeholder={recording ? 'Listening... speak now, tap yarn ball to stop' : transcribing ? 'Processing your voice...' : 'Share anything on your mind...'}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={handleKey}
            rows={1}
            disabled={recording || transcribing}
          />
          <button style={styles.sendBtn(input.trim() && !recording)} onClick={() => sendMessage()}>
            ↑
          </button>
        </div>
        {recording && (
          <div style={{ textAlign: 'center', marginTop: '8px', fontSize: '13px', color: '#F08080', fontWeight: 500 }}>
            🔴 Recording — tap the yarn ball to stop
          </div>
        )}
        {messages.length > 0 && (
          <div style={{ textAlign: 'center', marginTop: '12px' }}>
            <button
              onClick={endSession}
              style={{ background: 'transparent', border: '1px solid #EDE8E3', borderRadius: '999px', padding: '8px 20px', fontSize: '13px', color: '#A0A0A0', cursor: 'pointer' }}
            >
              ✕ End session & clear conversation
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
